import React, {useEffect, useState, useRef} from 'react';

import Close from "../assets/Close.svg"
import styled, {css} from 'styled-components/macro'
import {AnimatePresence, motion} from "framer-motion";
import Spinner from "./Spinner";

const AddLandButton = styled(motion.button)`    
    display: block;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 167px;
    height: 39px;
    left: 80%;
    top: 358px;
    

    /* yellow */

    background: linear-gradient(95.76deg, #FAC44E -0.92%, #F9AB12 96.25%);
    border-radius: 30px;
    border: none;
    
    font-weight: bold;
    font-size: 16px;
    
    /* or 25px */


    color: #FFFFFF;
    cursor: pointer;
    
    @media all and (max-width: 1444px) {
        margin-left: 0px;
        left: 1155px;
}

`

const Popup = styled(motion.div)`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.75);
    text-align: center;
    z-index: 3;
`

const PopupInner = styled(motion.div)`
    text-align: left;
    vertical-align: middle;
    position: absolute;
    max-width: 700px;
    width: 671px;
    top:50%;
    left:50%;
    transform: translate(-50%, -50%);
    padding: 40px;
    z-index: 4;
    
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    
    text-align: center;


`

const PopupHeader = styled.div`
    width: 100%;
    height: 24px;
    font-size: 19px;
    left: calc(50% - 623px/2);
    top: calc(50% - 24px/2 - 10px);
    line-height: 24px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-transform: capitalize;
`

const CloseButton = styled.a`
    width: 24px;
    margin-left: 420px;
    height: 24px;
    float: right;
    cursor: pointer;
`

const ContentArea = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 40px;    
`

const InputBoxContainer = styled.div`
    position: static;
    height: auto;
    top: 8px;
    margin-bottom: 20px;
`
const InputBoxLabel = styled.div`
    display: flex;
    flex-direction:row;
    align-items: center;
    padding-left: 5px;
    
    white-space: nowrap;
    position: relative;
    height: 20px;
    width: ${props => props.FixedWidth || "10%"}};
    left: 30px;
    top: 10px;
    font-weight: bold;
    
    background: #FFFFFF;
`

const Required = styled.div`
    font-size: 11px;
    line-height: 16px;

    color: #DA1414;

    opacity: 0.8;
`

const InputBox = styled.input`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    padding: 0px 15px;
    
    position: static;
    width: 95%;
    height: 48px;
    left: 0px;
    top: 0px;
    
    font-size: 16px;
    
    background: #FFFFFF;

    border: 1px solid #858C94;
    box-sizing: border-box;
    border-radius: 8px;
`

const BigInputBox = styled.textarea`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    padding: 15px 16px;
    
    position: static;
    width: 90%;
    height: 100px;
    left: 0px;
    top: 0px;
    
    font-size: 16px;
    background: #F4F6F9;
    border-radius: 8px;
    border: none;
    resize: none;    
    
    ${props => props.primary && css`
        width: 95%;
        background: #FFFFFF;
        border: 1px solid #858C94;
        box-sizing: border-box;
        border-radius: 8px;
    `}
`

const PopupFooter = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 40px;

`

const PopupButton = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    
    position: relative;
    width: 300px;
    height: 42px;
    margin: 15px;
    background: transparent;
    color: #FAC44E;
    border: 2px solid #FAC44E;

    border-radius: 30px;
    ${props => props.primary && css`
        background: #FAC44E;
        color: white;
    `}
    
    cursor: pointer;
`

const modalVariant = {
    initial: { opacity: 0 },
    isOpen: { opacity: 1 },
    exit: { opacity: 0 }
};
const containerVariant = {
    initial: { top: "-50%", transition: { type: "spring" } },
    isOpen: { top: "50%" },
    exit: { top: "-50%" }
};

const AddLandModal = (props) => {
    const [modal, setModal] = useState(false);
    const [landPropertyID, setLandPropertyID] = useState("");
    const [landAddress, setLandAddress] = useState("");
    const [zoning, setZoning] = useState("");
    const [note, setNote] = useState("");

    const [loading, setLoading] = useState(false);

    const toggle = () => {
        setLoading(false);
        setModal(!modal);
    };

    return (
        <AnimatePresence>
            <AddLandButton
                key={"addLandButton"}
                onClick={toggle}
                whileHover={{scale: 1.1}}
                whileTap={{scale: 0.9}}>
                十 Add Land
            </AddLandButton>
            {
                modal && (
                    <Popup
                        key={"popup"}
                        initial={"initial"}
                        animate={"isOpen"}
                        exit={"exit"}
                        variants={modalVariant}
                    >
                        <PopupInner
                            key={"popupInner"}
                            variants={containerVariant}>
                            <PopupHeader>
                                New Land Information
                                <CloseButton onClick={toggle}><img src={Close}/></CloseButton>
                            </PopupHeader>
                            { loading ? (<Spinner/>): (
                                <ContentArea>
                                    <InputBoxContainer>
                                        <InputBoxLabel FixedWidth={"20%"}>Land Property ID<Required>*</Required></InputBoxLabel>
                                        <InputBox
                                            type="number"
                                            onChange={
                                                e => { setLandPropertyID(e.target.value)}
                                            } required></InputBox>
                                    </InputBoxContainer>
                                    <InputBoxContainer>
                                        <InputBoxLabel>Address<Required>*</Required></InputBoxLabel>
                                        <BigInputBox primary onChange={e => setLandAddress(e.target.value)} required></BigInputBox>
                                    </InputBoxContainer>
                                    <InputBoxContainer>
                                        <InputBoxLabel FixedWidth={"9%"}>Zoning<Required>*</Required></InputBoxLabel>
                                        <InputBox onChange= {e => setZoning(e.target.value)} required></InputBox>
                                    </InputBoxContainer>
                                    <InputBoxContainer>
                                        <BigInputBox onChange={e => setNote(e.target.value)} placeholder="Note" type="text" cols=""/>
                                    </InputBoxContainer>
                                </ContentArea>
                            )}
                            <PopupFooter>
                                <PopupButton onClick={toggle}>Cancel</PopupButton>
                                <PopupButton onClick={() => {
                                    setLoading(true);
                                    props.action(landPropertyID, landAddress, zoning, note).catch(()=>{
                                        setLoading(false);
                                })}
                                }primary>Add Land</PopupButton>
                            </PopupFooter>
                        </PopupInner>
                    </Popup>
                )
            }
        </AnimatePresence>
    );
};

export default AddLandModal;
